/* Browser utilities. */

/** Copy the element's content string to the clipboard. */
export function copyToClipboard(event: MouseEvent) {
    const text = (event.target as HTMLElement).textContent || "";
    navigator.clipboard.writeText(text).then(() => {
        alert("Copied to clipboard: " + text);
    }).catch(err => {
        console.error("Failed to copy: ", err);
    });
}
